import { Graphics, Text, _ReactPixi } from '@inlet/react-pixi';
import { CustomPixiContainer } from 'components/CustomPixiContainer';
import { TextStyle } from 'pixi.js';
import { FC, useCallback, useMemo, useRef, useState } from 'react';
import * as PIXI from 'pixi.js';

type Props = {
  x: number;
  y: number;
  height: number;
  width: number;
  textSize: number;
  name?: string;
};

export const NameBadge: FC<Props> = ({ x, y, width, textSize, name }) => {
  const textRef = useRef<_ReactPixi.IText>(null);
  const [textHeight, setTextHeight] = useState(0);
  const [textWidth, setTextWidth] = useState(0);

  const style = useMemo(() => {
    return new TextStyle({
      align: 'left',
      fontFamily: 'sans-serif',
      fontSize: textSize,
      fontWeight: 'lighter',
      fill: ['#ffffff', '#ffffff'],
      stroke: '#eef1f5',
      strokeThickness: 1,
      letterSpacing: 2,
      wordWrapWidth: width,
    });
  }, [width, textSize]);

  const drawNameBorder = useCallback(
    (g: PIXI.Graphics) => {
      g.beginFill(0x353535, 1);
      g.drawRoundedRect(0, 0, Math.min(textWidth, width) + 20, textHeight + 10, 10);
      g.endFill();
      g.lineStyle(0);
    },
    [textWidth, width, textHeight]
  );

  return (
    <CustomPixiContainer
      key={name || 'key'}
      x={x}
      y={y}
      height={textHeight + 5}
      width={Math.min(textWidth, width) + 20}
    >
      <Graphics key={textWidth} draw={drawNameBorder} visible={!!name} />
      <Text
        text={name || ''}
        style={style}
        x={10}
        y={5}
        ref={(e) => {
          setTextHeight(e?.texture.orig.height || 0);
          setTextWidth(e?.texture.orig.width || 0);
          return textRef;
        }}
      />
    </CustomPixiContainer>
  );
};
